<template>
  <wui-modal
    :title="$t('common.error')"
    :size="40"
    :closable="true"
    class="!w-[360px]"
  >
    <div class="text-center px-4 py-6">
      <wui-icon
        name="exclamationCircleOutlined"
        class="w-16! h-16! text-warning!"
      />
      <div class="pt-6">
        <div class="text-1316">
          <b>{{ $t('common.errorType') }}:</b> {{ error.message }}
        </div>
      </div>
    </div>

    <template #footer>
      <wui-btn
        :size="40"
        variant="neut"
        state="alpha"
        @click="close()"
      >
        {{ $t('common.close') }}
      </wui-btn>
    </template>
  </wui-modal>
</template>
<script lang="ts" setup>
import { WuiBtn, WuiIcon, WuiModal, closeDialogKey, safeInject } from '@wui/common-library'

defineProps<{
  error: Error
}>()

const closeDialog = safeInject(closeDialogKey)

const close = () => {
  closeDialog(undefined)
}
</script>
